import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/extensions
import { A } from '../A';
import './MessageModal.css';

const MessageModal = ({ onDismiss, mesgToDisplay, encrypted, MesgType, intl }) => (
  <div className="status-msg">
    {MesgType !== 'success' ? (
      <div className="error-msg">
        {encrypted ? intl.formatMessage({ id: mesgToDisplay }) : mesgToDisplay}
        <A className="link float-right" href="" onClick={onDismiss}>
          {intl.formatMessage({ id: 'ErrorMessage.Dismiss'})}
        </A>{' '}
      </div>
    ) : (
      <div className="success-msg">
        {encrypted ? intl.formatMessage({ id: mesgToDisplay }) : mesgToDisplay}
        <A className="link float-right" href="" onClick={onDismiss}>
          {intl.formatMessage({ id: 'ErrorMessage.Dismiss'})}
        </A>{' '}
      </div>
    )}
  </div>
);

MessageModal.propTypes = {
  mesgToDisplay: PropTypes.string.isRequired,
  MesgType: PropTypes.string.isRequired,
  encrypted: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  intl: PropTypes.arrayOf(
    PropTypes.shape({
      locale: PropTypes.string.isRequired,
      formatMessage: PropTypes.func.isRequired,
    })
  ).isRequired,
};

export default injectIntl(MessageModal);
